import type { Guide } from '../types';

/** S-22.10-02 — pomiar użycia aplikacji (decyzja użytkownika 22.10.2026; scenariusz e2e 24). */
export const guide: Guide = {
  flagKey: 'usageTelemetry',
  title: 'Pomiar użycia aplikacji',
  whatItDoes:
    'Aplikacja zapisuje, kto z jakiego działu wchodzi na które ekrany i ile na nich jest, klika które przyciski, zakładki, pozycje menu i wiersze list, co zapisuje i zmienia (z kodem odpowiedzi), otwiera które okna, zmienia które filtry, eksportuje i kiedy się wylogowuje — z numerem zlecenia, żeby złożyć przejście przez działy. Treści pól, wartości filtrów, treści komórek, nazw kontrahentów i kierowców ani innych danych osobowych nie zapisujemy, tylko numer konta. Ekran „Pomiar użycia” (tylko administrator) pokazuje ścieżki pracy: ile przejść się zaczęło i skończyło, gdzie się zatrzymują i ile trwały, a do tego najczęstsze ekrany i przyciski, odmowy i błędy oraz aktywność dzienną działów.',
  audience: ['administrator'],
  presentationItems: ['S-22.10-02'],
  steps: [
    {
      route: '/usage-analytics',
      target: 'usage-intro',
      title: 'Co zapisujemy, a czego nie',
      description:
        'Na górze ekranu jest opis pomiaru i przypomnienie, że to pomiar pracy pracowników klienta — przed pilotażem trzeba ich o nim poinformować. Obok: jak długo przechowujemy zdarzenia (domyślnie bez limitu) i na którym środowisku jesteś.',
      action: 'W menu „Administracja” otwórz „Pomiar użycia” i przeczytaj opis.',
      recorder: { account: 'admin' },
    },
    {
      route: '/usage-analytics',
      target: 'usage-filters',
      title: 'Okres, dział, rola, konto i środowisko',
      description:
        'Domyślnie ostatnie 7 dni. Filtry zawężają wszystkie widoki naraz; listy działów, ról i kont pokazują tylko to, co w wybranym okresie wystąpiło.',
      action: 'Ustaw okres i wybierz dział albo konto.',
      recorder: { account: 'admin' },
    },
    {
      route: '/usage-analytics',
      target: 'usage-path-row-*',
      title: 'Ścieżki pracy',
      description:
        'Dla każdej ścieżki: ile przejść się zaczęło i ile doszło do końca (w nawiasie liczba osób), na którym kroku się zatrzymują i mediana czasu przejścia. Przejście to jedno zlecenie przez kolejne działy; krok bez odpowiednika w aplikacji jest pomijany.',
      action: 'Przejrzyj kolumny „Gdzie się zatrzymują” i „Mediana czasu”; „Eksport CSV” zapisuje tabelę.',
      recorder: { account: 'admin' },
    },
    {
      route: '/usage-analytics',
      target: 'usage-tab-screens',
      title: 'Ekrany, przyciski, odmowy i aktywność',
      description:
        'Zakładki pokazują najczęściej używane ekrany i przyciski (z oznaczeniem elementów z kontraktu ścieżek), odmowy i błędy według ekranu oraz aktywność dzienną działów — każda z eksportem do pliku.',
      action: 'Kliknij zakładkę „Ekrany i przyciski”, potem „Odmowy i błędy” i „Aktywność dzienna”.',
      recorder: { account: 'admin', actions: [{ kind: 'click', target: 'usage-tab-screens' }] },
    },
    {
      route: '/usage-analytics',
      target: 'usage-tab-actions',
      title: 'Działania, kliknięcia i oś czasu konta',
      description:
        '„Działania” to każde zapisanie, zmiana i czynność wysłana z ekranu — z kodami odpowiedzi i czasem. „Kliknięcia” pokazują przyciski, zakładki i wiersze list z napisem z ekranu i sekcją. „Oś czasu konta” — po wybraniu konta w filtrze — pokazuje po kolei, kto co i kiedy zrobił. „Eksport wszystkich zdarzeń (CSV)” zapisuje całość z bieżącymi filtrami.',
      action: 'Kliknij „Działania”, potem „Kliknięcia”; wybierz konto i otwórz „Oś czasu konta”.',
      recorder: { account: 'admin', actions: [{ kind: 'click', target: 'usage-tab-actions' }] },
    },
    {
      route: '/usage-analytics',
      target: 'usage-purge-open',
      title: 'Usuwanie starszych danych',
      description:
        'Zdarzeń nie usuwamy automatycznie — trzymamy je, aż administrator je usunie. „Usuń dane starsze niż…” pyta o dzień, pokazuje, ile zdarzeń zniknie, i wymaga powodu; usunięcie dotyczy całego pomiaru (nie tylko filtrów) i trafia do dziennika działań.',
      action: 'Kliknij „Usuń dane starsze niż…”, wybierz dzień i sprawdź liczbę zdarzeń — bez powodu przycisk usuwania jest nieaktywny.',
      recorder: { account: 'admin' },
    },
    {
      route: '/suggestion-parameters',
      target: 'suggestion-parameter-usageEventRetentionDays',
      title: 'Jak długo trzymamy zdarzenia',
      description:
        'Parametr „Pomiar użycia: przechowywanie zdarzeń”: domyślnie 0 — bez limitu, codzienne czyszczenie nic nie usuwa. Liczba dni (7–730) włącza codzienne usuwanie starszych zdarzeń; zmiana wymaga powodu i trafia do historii parametru.',
      action: 'Otwórz „Parametry rekomendacji” i znajdź wiersz „Pomiar użycia: przechowywanie zdarzeń”.',
      recorder: { account: 'admin' },
    },
  ],
};
